/**
 * @voltxampere/web — Canvas store derivation (Sprint 12).
 *
 * Projects the active `Circuit` through `sceneFromCircuit` using
 * a default viewport. The host `<vxa-canvas>` element builds its
 * own selection-aware Scene internally; this signal is the
 * store-side "what would the canvas show right now" projection
 * other UI surfaces can subscribe to (Sprint 14 inspector
 * mini-map, Sprint 19 thumbnail export).
 *
 * Lifting the live viewport into the store is a Sprint 14+
 * concern — Sprint 12 keeps it scoped to the canvas element so
 * pan / zoom interactions do not ripple through the rest of the
 * shell every frame.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import { signal, type Signal } from "@preact/signals-core";

/**
 * Sprint 14 — lift the canvas selection into the store so the
 * inspector (and any future read-only consumer) can subscribe
 * without poking inside `<vxa-canvas>`. The canvas element still
 * owns the write path; everyone else only reads.
 */
export const selectedNodes: Signal<readonly string[]> = signal<readonly string[]>([]);
